if (!customElements.get('vv-first-order-offer')) {
  customElements.define('vv-first-order-offer', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.sessionKey = 'vv:first-order:v1:session';
      this.dismissKey = 'vv:first-order:v1:dismissed-until';
      this.state = this.readSession();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (Number(this.dataset.cartCount) > 0 || this.dataset.page === 'cart') this.suppress();
      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' || event.cartData?.item_count > 0) this.suppress();
        });
      }
      if (!this.dialog) return;
      this.querySelector('[data-offer-open]').addEventListener('click', (event) => {
        event.preventDefault();
        this.open(true);
      }, options);
      this.querySelectorAll('[data-offer-close]').forEach((button) => {
        button.addEventListener('click', () => this.dismiss(), options);
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      }, options);
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dismiss();
      }, options);
      this.lastTick = performance.now();
      this.wasActive = this.active();
      const tick = () => this.tick();
      document.addEventListener('visibilitychange', tick, options);
      window.addEventListener('blur', tick, options);
      window.addEventListener('focus', tick, options);
      window.addEventListener('pagehide', tick, options);
      this.timer = setInterval(tick, 250);
    }

    readSession() {
      try { return JSON.parse(sessionStorage.getItem(this.sessionKey)) || { elapsed: 0 }; }
      catch { return { elapsed: 0 }; }
    }

    save() {
      try { sessionStorage.setItem(this.sessionKey, JSON.stringify(this.state)); } catch { /* Browsing still works without storage. */ }
    }

    active() { return document.visibilityState === 'visible' && document.hasFocus(); }

    blocked() {
      if (document.activeElement?.matches('input, textarea, select, [contenteditable]:not([contenteditable="false"])')) return true;
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, cart-notification.active, details[open]')]
        .some((element) => element !== this.dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    }

    tick() {
      const now = performance.now();
      const active = this.active();
      if (this.wasActive && active) this.state.elapsed = Math.min(12000, (Number(this.state.elapsed) || 0) + now - this.lastTick);
      this.lastTick = now;
      this.wasActive = active;
      this.save();
      if (this.state.elapsed >= 12000) this.open(false);
    }

    open(manual) {
      if (this.dialog.open || !this.active() || this.blocked()) return;
      if (!manual) {
        if (this.dataset.editor === 'true' || this.state.shown || this.state.cart) return;
        try { if (Number(localStorage.getItem(this.dismissKey)) > Date.now()) return; } catch { /* Session guard remains available. */ }
      }
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.state.shown = true;
      this.save();
    }

    dismiss() {
      try { localStorage.setItem(this.dismissKey, String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch { /* Keep the in-memory/session guard. */ }
      this.dialog.close();
      this.returnFocus?.focus({ preventScroll: true });
    }

    suppress() {
      this.state.cart = true;
      this.save();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller?.abort();
      this.unsubscribe?.();
    }
  });
}
